export default __webpack_public_path__ + "static/telegramLogo-856b622f6a137ab593264edcc4cbd39a.svg";